export default __webpack_public_path__ + "static/media/whyBrokerVTGMIcon2.23a29329.webp";